module.exports = __webpack_public_path__ + "img/jionUsBg@2x.3560ea54.png";